const ImportExportArrow = props => (
	<svg
		width="15"
		height="16"
		viewBox="0 0 15 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g id="import_export">
			<path
				id="Vector"
				d="M5.625 2.375L3.125 4.86875H5V9.25H6.25V4.86875H8.125L5.625 2.375ZM10 11.1313V6.75H8.75V11.1313H6.875L9.375 13.625L11.875 11.1313H10Z"
				fill="black"
			/>
		</g>
	</svg>
);

export default ImportExportArrow;
